module.exports = __webpack_public_path__ + "img/4.6c1f6d1f.jpg";